export const getStatus = status => {
  switch (String(status)) {
    case '0':
      return { status: '待支付', style: { color: '#ff801a' } }
    case '1':
      return { status: '已支付', style: { color: '#02ca5b' } }
    case '2':
      return { status: '已关闭', style: { color: '#999' } }
    case '3':
      return { status: '审批中', style: { color: '#333' } }
    case '4':
      return { status: '审批拒绝', style: { color: '#333' } }
    case '5':
      return { status: '未发送', style: { color: '#999' } }
    case '6':
      return { status: '已终止', style: { color: '#999' } }
    default:
      return { status: '', style: { color: '#ff801a' } }
  }
}

export const formatPrice = price => {
  if (isNaN(price)) {
    return null
  }
  return '¥ ' + price
}

/**
 * 时间戳转换成2017-12-21 09:01:22 格式的时间
 */
const filter = str => {
  if (String(str).length < 2) {
    return '0' + str
  } else {
    return str
  }
}

export const fromatTime = num => {
  let date = new Date(num)
  const o = {
    'Y+': date.getFullYear(), //年份
    'M+': date.getMonth() + 1, //月份
    'D+': date.getDate(), //日
    'H+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds() //秒
  }
  return (
    o['Y+'] +
    '-' +
    filter(o['M+']) +
    '-' +
    filter(o['D+']) +
    ' ' +
    filter(o['H+']) +
    ':' +
    filter(o['m+']) +
    ':' +
    filter(o['s+'])
  )
}

export const getTotalPrice = (items, property) => {
  let arry = items || []
  let totalPrice = 0
  arry.forEach(item => {
    if (item && item[property]) {
      totalPrice += +item[property]
    }
  })
  return totalPrice
}
